import * as THREE from 'three';

/** 正交相机位置与 near/far，与编辑器 2d 相机一致 */
const CAMERA_Z = 500;
const CAMERA_NEAR = 1;
const CAMERA_FAR = 600;

/** 取景框补到输出画面的宽高比，避免画面被拉伸；短的那一边留白 */
export const fitViewToAspect = (viewWidth: number, viewHeight: number, outputAspect: number) => {
  if (outputAspect > viewWidth / viewHeight) {
    return { viewWidth: viewHeight * outputAspect, viewHeight };
  }
  return { viewWidth, viewHeight: viewWidth / outputAspect };
};

/** 让内容居中铺满画面的正交相机 */
export const createFitOrthographicCamera = (params: {
  center: { x: number; y: number };
  viewWidth: number;
  viewHeight: number;
}) => {
  const { center, viewWidth, viewHeight } = params;

  const camera = new THREE.OrthographicCamera(
    -viewWidth / 2,
    viewWidth / 2,
    viewHeight / 2,
    -viewHeight / 2,
    CAMERA_NEAR,
    CAMERA_FAR
  );
  camera.position.set(center.x, center.y, CAMERA_Z);
  camera.lookAt(center.x, center.y, 0);
  camera.updateProjectionMatrix();

  return camera;
};

/** 从包围盒算出居中铺满的取景参数：加留白，再补到输出比例 */
export const resolveFitView = (bounds: THREE.Box3, outputAspect: number, padding: number) => {
  const size = bounds.getSize(new THREE.Vector3());
  const center = bounds.getCenter(new THREE.Vector3());
  const paddedWidth = size.x * (1 + padding * 2);
  const paddedHeight = size.y * (1 + padding * 2);

  if (!(paddedWidth > 0) || !(paddedHeight > 0)) return undefined;

  const { viewWidth, viewHeight } = fitViewToAspect(paddedWidth, paddedHeight, outputAspect);

  return { center, viewWidth, viewHeight };
};
